<template>
  <div>
    <template v-if="memberIdentity">
      <v-card flat>
        <v-card-text>
          <v-form v-model="valid">
            <v-row class="pa-0">
              <v-col cols="auto">
                <v-btn
                  color="primary"
                  text
                  @click="
                    $router.push({
                      name: 'memberView',
                      params: {
                        id: memberIdentity.Id,
                        planId: memberIdentity.PlanIdentityId,
                      },
                    })
                  "
                >
                  {{ $t("globals.view_details") }}
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <template>
                  <span class="minfo">
                    {{ $t("headers.members_management.Certificate") }}
                  </span>
                  <br />
                  <span
                    v-if="
                      memberIdentity.MemberIdentification &&
                      memberIdentity.MemberIdentification.Certificate
                    "
                  >
                    {{ memberIdentity.MemberIdentification.Certificate }}
                  </span>
                </template>
              </v-col>
              <v-col
                cols="auto"
                v-if="Object.keys(headersDictionary).indexOf('First Name') > -1"
              >
                <template>
                  <span class="minfo">
                    {{ $t("headers.members_management.First Name") }}
                  </span>
                  <br />
                  <span v-if="memberIdentity.CurrentMember.FirstName">
                    {{ memberIdentity.CurrentMember.FirstName }}
                  </span>
                </template>
              </v-col>
              <v-col
                cols="auto"
                v-if="
                  Object.keys(headersDictionary).indexOf('Middle Name') > -1
                "
              >
                <template>
                  <span class="minfo">
                    {{ $t("headers.members_management.Middle Name") }}
                  </span>
                  <br />
                  <span v-if="memberIdentity.CurrentMember.MiddleName">
                    {{ memberIdentity.CurrentMember.MiddleName }}
                  </span>
                </template>
              </v-col>
              <v-col
                cols="auto"
                v-if="Object.keys(headersDictionary).indexOf('Last Name') > -1"
              >
                <template>
                  <span class="minfo">
                    {{ $t("headers.members_management.Last Name") }}
                  </span>
                  <br />
                  <span v-if="memberIdentity.CurrentMember.LastName">
                    {{ memberIdentity.CurrentMember.LastName }}
                  </span>
                </template>
              </v-col>
              <v-col cols="auto">
                <template>
                  <span class="minfo">
                    {{ $t("headers.contacts.email") }}
                  </span>
                  <br />
                  <span v-if="memberIdentity.Email">
                    {{ memberIdentity.Email }}
                  </span>
                </template>
              </v-col>
              <v-col
                cols="auto"
                v-if="Object.keys(headersDictionary).indexOf('Country') > -1"
              >
                <span class="minfo">
                  {{ $t("headers.members_management.Address") }}
                  <br />
                </span>
                <span @click="addressDialog = true">
                  {{ displayAddress() }}
                </span>
                <v-btn
                  v-if="
                    !(
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    )
                  "
                  small
                  text
                  @click="addressDialog = true"
                >
                  {{ $t("globals.add") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="addressDialog" persistent max-width="1200">
      <material-card
        v-if="addressDialog"
        :title="
          memberIdentity.CurrentContactInformation &&
          memberIdentity.CurrentContactInformation.Address
            ? $t('components.claims.member_details.edit_address_{0}', [
                getName(),
              ])
            : $t('components.claims.member_details.add_address_{0}', [
                getName(),
              ])
        "
        icon="contact_mail"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <template v-if="effectiveDate">
            <span class="text-h6 ml-1 required-label">
              {{ $t("globals.address") }}
            </span>
            <canada-post-address
              :address="contactInfo.Address"
              @update-address="contactInfo.Address = $event"
              @valid="validAddress=$event"
              :isRequired="true"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              addressDialog = false;
              address = null;
              effectiveDate = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="!effectiveDate || !validAddress"
            color="primary"
            @click="saveContactInfo"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler.vue";
import { translate2 } from "@/trans2";
import { locker } from "@/mixins/locker";
import CanadaPostAddress from "@/components/CanadaPostAddress.vue";
export default {
  components: {
    ErrorHandler,
    CanadaPostAddress,
  },
  props: {
    memberIdentity: {
      type: Object,
      default: () => null,
    },
  },
  mixins: [locker],
  data() {
    return {
      error: null,
      effectiveDate: null,
      headersDictionary: {},
      addressDialog: false,
      saving: false,
      contactInfoQuery: null,
      contactInfo: null,
      valid: false,
      loading: false,
      validAddress: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
    };
  },
  watch: {
    memberIdentity: {
      handler(v) {
        if (v) {
          this.loadMemberDetails();
        }
      },
      immediate: true,
    },
    addressDialog: {
      async handler(v) {
        if (v) {
          this.effectiveDate = this.memberIdentity.PlanEntryDate;
          this.loadAddress(this.effectiveDate);
        }
      },
    },
  },
  computed: {},
  mounted() {
    if (this.memberIdentity) {
      this.loadMemberDetails();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
      "getContactInfoByEffectiveDate",
      "updateMemberContactInfo",
    ]),
    async loadAddress(effectiveDate) {
      this.loading = true;
      try {
        let contactInfo;
        if (this.lockId) {
          contactInfo = (
            await this.getContactInfoByEffectiveDate({
              planIdentityId: this.memberIdentity.PlanIdentityId,
              memberIdentityId: this.memberIdentity.Id,
              effectiveDate: effectiveDate,
              odataQuery: this.contactInfoQuery,
            })
          ).data;
        } else {
          contactInfo = await this.lock(
            this.getContactInfoByEffectiveDate,
            {
              planIdentityId: this.memberIdentity.PlanIdentityId,
              memberIdentityId: this.memberIdentity.Id,
              effectiveDate: effectiveDate,
              odataQuery: this.contactInfoQuery,
              dialogs: this.dialogs,
              dialog: "contactInfo",
            },
            () => {
              this.addressDialog = false;
            }
          );
        }
        //console.log(contactInfo);
        if (!contactInfo) {
          contactInfo = {
            // Address: {},
            // Identity: {},
          };
        }

        this.contactInfo = contactInfo;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    getName() {
      // console.log(this.memberIdentity);
      if (this.memberIdentity === null || this.memberIdentity === undefined) {
        return;
      }
      if (this.memberIdentity.CurrentMember) {
        if (
          this.memberIdentity.CurrentMember.FirstName &&
          this.memberIdentity.CurrentMember.LastName
        ) {
          return `${this.memberIdentity.CurrentMember.FirstName} ${this.memberIdentity.CurrentMember.LastName}`;
        } else if (this.memberIdentity.CurrentMember.FirstName) {
          return this.memberIdentity.CurrentMember.FirstName;
        } else if (this.memberIdentity.CurrentMember.LastName) {
          return this.memberIdentity.CurrentMember.LastName;
        }
      }
      if (this.memberIdentity.MemberIdentification.Certificate) {
        return this.memberIdentity.MemberIdentification.Certificate;
      }
      return "";
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    async saveContactInfo() {
      this.saving = true;
      try {
        let member = JSON.parse(JSON.stringify(this.contactInfo));

        if (member.LanguageChoice) {
          member.LanguageChoiceId = member.LanguageChoice.Id;
          delete member.LanguageChoice;
        }
        if (member.CommunicationPreference) {
          member.CommunicationPreferenceId = member.CommunicationPreference.Id;
          delete member.CommunicationPreference;
        }
        if (member.Address) {
          if (Object.keys(member.Address).length > 0) {
            if (member.Address.Country) {
              member.Address.CountryId = member.Address.Country.Id;
              delete member.Address.Country;
            }
            if (member.Address.Province) {
              member.Address.ProvinceId = member.Address.Province.Id;
              delete member.Address.Province;
            }
            // member.Address.PostalCode = this.unmask(member.Address.PostalCode, this.postalCodeMask);
          } else {
            delete member.Address;
          }
        } else {
          delete member.Address;
        }

        // if (member.PhoneNumber!== null && member.PhoneNumber !== undefined) {
        //   member.PhoneNumber = this.unmask(member.PhoneNumber, this.telephoneMask);
        // }

        delete member["@odata.context"];
        // delete member.Identity;

        member.EffectiveDate = this.effectiveDate;
        member.IdentityId = this.memberIdentity.Id;
        member.PlanIdentityId = this.memberIdentity.PlanIdentityId;

        if (member.SourceOfInformation) {
          member.SourceOfInformationId = member.SourceOfInformation.Id;
          delete member.SourceOfInformation;
        }

        await this.updateMemberContactInfo({
          planIdentityId: this.memberIdentity.PlanIdentityId,
          memberIdentityId: this.memberIdentity.Id,
          payload: member,
        });
        this.addressDialog = false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.address = null;
        this.effectiveDate = null;
        this.$emit("reload-member-identity");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    coverageAllowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.memberIdentity.PlanEntryDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    async loadMemberDetails() {
      this.loading = true;
      try {
        const headers = (
          await this.getMembersManagementColumns(
            this.memberIdentity.PlanIdentityId
          )
        ).data;
        for (const header of headers) {
          if (header.onEdit === "Edit" || header.onEdit === "View") {
            this.headersDictionary[header.text] = header;
          }
        }
        this.contactInfoQuery = this.$helpers.createContactInfoQuery(headers);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    displayAddress() {
      let res = "";
      // console.log(this.memberIdentity);
      if (
        this.memberIdentity.CurrentContactInformation &&
        this.memberIdentity.CurrentContactInformation.Address
      ) {
        // console.log("address:   -----------------------", this.memberIdentity);
        if (this.memberIdentity.CurrentContactInformation.Address.SuiteNumber) {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.SuiteNumber;
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.StreetNumber
        ) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetNumber.toString();
        }
        if (this.memberIdentity.CurrentContactInformation.Address.StreetName) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetName;
        }
        if (res.length > 0) {
          res += ", ";
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.Country.IsOther
        ) {
          res += this.memberIdentity.CurrentContactInformation.Address.City;
          if (
            this.memberIdentity.CurrentContactInformation.Address.OtherProvince
          ) {
            res +=
              ", " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherProvince;
          }
          if (
            this.memberIdentity.CurrentContactInformation.Address
              .OtherPostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherPostalCode;
          }
          res +=
            " " +
            this.memberIdentity.CurrentContactInformation.Address.OtherCountry;
        } else {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.City +
            ", " +
            this.memberIdentity.CurrentContactInformation.Address.Province.Code;
          if (
            this.memberIdentity.CurrentContactInformation.Address.PostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address.PostalCode;
          }
        }
      }
      return res;
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
